import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.events.grayShade2,
    color: theme.palette.text.primary,
    borderRadius: "5px",
    border: `1px solid ${theme.palette.events.grayShade1}`,
    boxShadow: "4px 4px 4px 0px #0C38911A",
    width: "100%",
    padding: `${theme.spacing(2.5)} ${theme.spacing(5)}`,
    [theme.breakpoints.down("md")]: {
      padding: `${theme.spacing(2.5)} ${theme.spacing(2.5)}`,
    },
  },
  cardInner: {
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  title: {
    margin: "5px 0",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  icon: {
    width: "30px",
    height: "30px",
  },
  subtitle: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  searchContainer: {
    width: "100%",
    marginRight: "auto",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  contactUs: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.down("lg")]: {
      justifyContent: "center",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  searchInputAdornment: {
    paddingRight: theme.spacing(1),
    marginRight: 0,
    color: theme.palette.events.grayTertiary,
    padding: "8px 12px 6px",
  },
  inputClass: {
    maxHeight: "38px !important",
    width: "416px",
    boxShadow: "none !important",
  },
  contactUsButton: {
    fontSize: "16px",
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  search: {
    width: "400px",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
}));
